import { useFormikContext } from 'formik';
import React, { useMemo } from 'react';

import { Box, Grid } from '@mui/material';

import { FormState } from '../types';
import { CARDS_DATA } from './consts';
import { PerkCardV2 } from './perk-card-2';

interface PerksListProps {}

export const PerksList = (props: PerksListProps) => {
  const { values } = useFormikContext<FormState>();
  const finalPerks = useMemo(() => {
    const cat = values.category;
    const loc = values.location;
    let filtered = CARDS_DATA;
    if (loc) {
      filtered = filtered.filter((i) => !i.regions || i.regions.includes(loc));
    }
    if (cat) {
      filtered = filtered.filter((i) => i.subtitle === cat);
    }
    return filtered.reverse();
  }, [values]);

  return (
    <Box>
      <Grid container spacing={4}>
        {finalPerks.map((item) => (
          <Grid key={item.title} item lg={6}>
            <PerkCardV2 {...item} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
